/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */



var Model = require("../types/Model.js");

var prop = require("prop");
var xtend = require("xtend");

module.exports = Model({
	name: "managedreminders",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_who_tracker: null,
	_localization: null,
	_people: null,

	track: track,
	refresh: refresh,
	reset: reset,
	sayViewing: sayViewing
});

function init() {
	this._people = {};
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker();
	this.reset();
}

function uninit() {
	this._who_tracker.off();
	this._who_tracker = null;
	this._who = null;
	this._people = null;
	this._localization = null;
}

function reset() {
	this._who = null;
	this._who_tracker.off();
	this.push({
		list: [],
		removing: false
	});
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_updated,
		"localization:updated": handle_localization_updated
	};
}

function triggers() {
	return {
		"remove": handle_trigger_remove,
		"remove:start": handle_trigger_remove_start,
		"remove:cancel": handle_trigger_remove_cancel,
		"remove:confirm": handle_trigger_remove_confirm,
		"add": handle_trigger_add,
		"edit": handle_trigger_edit,
		"view": view,
		"reset": trigger_reset
	};
}

function view(data) {
	var who = data.who;
	const group = data.group;

	if (this._who === who) return;
	this._who = who;
	this._group = group;

	var account = this._people[who];

	if (!account) return;

	var types = account.type;

	if (types.indexOf("reminders") === -1)
		return console.warn("Managed person:", account, "doesn't have reminders");

	this.emit("managedpendingreminders:trigger:view", data);
	this.emit("managedreminderhistory:trigger:view", data);

	this.track();
	this.refresh().then(sayViewing.bind(this));
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who
	});
	this.emit("usermetrics:trigger:track", "view managed user's reminders", {
		who: this._who
	});
}

function trigger_reset() {
	this.reset();
	this.emit("managedpendingreminders:trigger:reset");
	this.emit("usermetrics:trigger:track", "close managed user's reminders");
}

function handle_trigger_remove(data) {
	var reminder = data.reminder;

	this._to_remove = reminder;

	this.dispatch("removing");

	this.emit("usermetrics:trigger:track", "delete managed user's reminder", {
		who: this._who
	});
}

function handle_trigger_remove_start(data) {
	var reminder = data.reminder;
	this._to_remove = reminder;
	this.extend({
		removing: reminder
	});

	this.emit("usermetrics:trigger:track", "begin deleting managed user's reminder", {
		who: this._who
	});
}

function handle_trigger_remove_cancel() {
	this.extend({
		removing: false
	});
	this.emit("usermetrics:trigger:track", "cancel delete managed user's reminder", {
		who: this._who
	});
}

function handle_trigger_remove_confirm() {
	this.emit("save:trigger:start");
	var who = this._who;
	var reminder = this._to_remove;
	const group = this._group;

	this.api.manage.reminders
		.remove(who, reminder, group)
		.catch(console.error.bind(console))
		.then(removeFinished.bind(this));

	this.emit("usermetrics:trigger:track", "remove managed user's reminder", {
		who: this._who
	});
}

function removeFinished() {
	this.dispatch("removed");
	this.emit("save:trigger:finish");
	this.dispatch("viewed", {
		who: this._who,
		section: "reminders",
		timestamp: new Date().toISOString(),
	});
	this.emit("toast:trigger:show", {
		content: "remindermaker.deleted",
		style: "error"
	});
}

function handle_trigger_add(data) {
	var who = this._who;
	const group = this._group;
	var content = data.content;
	var schedule = data.schedule;
	var notification = data.notification;
	var type = data.responseType;

	this.emit("save:trigger:start");

	this.api.manage.reminders
		.add(who, content, schedule, notification, type, group)
		.catch(console.error.bind(console))
		.then(addFinished.bind(this));

	this.emit("usermetrics:trigger:track", "add reminder for managed user", {
		who: this._who
	});
}

function addFinished() {
	this.emit("save:trigger:finish");
	this.dispatch("viewed", {
		who: this._who,
		section: "reminders",
		timestamp: new Date().toISOString(),
	});
}

function handle_trigger_edit(data) {
	this.emit("save:trigger:start");
	var who = this._who;
	const group = this._group;
	var reminder = data.reminder;
	var content = data.content;
	var schedule = data.schedule;
	var notification = data.notification;
	var type = data.responseType;

	this.api.manage.reminders
		.edit(who, reminder, content, schedule, notification, type, group)
		.catch(console.error.bind(console))
		.then(addFinished.bind(this));

	this.emit("usermetrics:trigger:track", "edit reminder for managed user", {
		who: this._who
	});
}

function refresh() {
	var who = this._who;
	const group = this._group;
	if (!who) return;

	this.emit("save:trigger:start");
	return this.api.manage.reminders
		.list(who, group)
		.then(handle_refresh_success.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function track() {
	var who = this._who;
	var tracker = this._who_tracker;

	tracker.off();

	var do_refresh = refresh.bind(this);

	var group = this._group;
	if(group) {
		if(Array.isArray(group)) {
			group.forEach(g=>{
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/reminders/removed", do_refresh);
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/reminders/added", do_refresh);
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/reminders/edited", do_refresh);
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/reminders/history/update", do_refresh);
			});
		} else {
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/reminders/removed", do_refresh);
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/reminders/added", do_refresh);
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/reminders/edited", do_refresh);
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/reminders/history/update", do_refresh);
		}
	} else {
		tracker.on("mqtt:u/" + who + "/reminders/removed", do_refresh);
		tracker.on("mqtt:u/" + who + "/reminders/added", do_refresh);
		tracker.on("mqtt:u/" + who + "/reminders/edited", do_refresh);
		tracker.on("mqtt:u/" + who + "/reminders/history/update", do_refresh);
	}
}

function handle_refresh_success(list) {
	var localization = this._localization;
	var lang = localization.language;
	// Add in a human readable form for the reminder schedule
	var formatted = list.filter(prop("schedule")).map(function (item) {
		var latestHistory = item.latestHistory;
		var historyUpdate = latestHistory ? {
			latestHistory: xtend(latestHistory, {
				readable: getHistoryTimestamp(latestHistory, lang),
				response: getHistoryResponse(latestHistory)
			})
		} : {};

		return xtend(item, {
			readable: format_time(localization, item.schedule)
		}, historyUpdate);
	});
	this.extend({
		list: formatted
	});
}

function getHistoryResponse(history) {
	if (history.accepted) return "Accepted";

	if (history.denied) return "Denied";

	if (history.cleared) return "Cleared";

	return history.response || history.response === 0 ? history.response : "N/A";
}

function format_time(localization, schedule) {
	var parts = schedule.split(" ");
	var read_hr = parts[1].split("-")[0];
	var read_min = parts[0];
	if (read_min.length === 1) read_min = "0" + read_min;
	var read_days = format_cron(parts, localization.localization, localization.language);

	var readable = read_hr + ":" + read_min + " - " + read_days;

	return readable;
}

function handle_localization_updated(localization) {
	this._localization = localization;
}

function format_cron(parts, localization, lang) {
	var days = parts[parts.length - 1];
	var month = parts[3];
	var day = parts[2];
	var isMonths = month !== "*" && day !== "*";

	if (days === "*" && !isMonths)
		return localization.reminders.ae_managedreminder_everyday;

	var locale = checkLanguage(lang);

	var localizationAbbr = localization.reminders.ae_abbr_days || {};
	var localizationPrefix = localization.reminders.every;

	if (isMonths)
		return new Date(new Date().getFullYear(), month, day).toLocaleDateString(locale, getDateOptions());
	else
		return (localizationPrefix + days.split(",").map(function (item) {
			return " " + localizationAbbr[item] || "";
		})
		);
}

function handle_people_updated(people) {
	this._people = people;
}

function getHistoryTimestamp(latestHistory, lang) {
	var time = latestHistory.accepted || latestHistory.denied || latestHistory.cleared || latestHistory.responded;
	if (!time) return "";
	var locale = checkLanguage(lang);
	return timestamp(time, locale);
}

// Converts a date timestamp into a human readable timestamp
function timestamp(value, lang) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	return (padNumber(d.getHours()) + ":" + padNumber(d.getMinutes()) + " - " + d.toLocaleDateString(lang, getDateOptions()));
}

function padNumber(number) {
	if (number < 10) return "0" + number;
	return number;
}

function checkLanguage(lang) {
	if (lang === "cn_s") return "zh-CN";
	else if (lang === "cn_t") return "zh-HK";
	else return lang;
}

function getDateOptions() {
	return {
		weekday: "short",
		month: "short",
		day: "2-digit"
	};
}
